import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import Constants from "../common/Constants";
import { IOrganisationIndex } from "../model/OrganisationIndex";
export default class ConnectIndexesByCategoryInteractor {
  private createListResource: CreateListResourceInteractor<IOrganisationIndex>;
  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }
  async execute(
    organisationIndexId: number,
    organisationIndexes: IOrganisationIndex[],
    organisationId: number
  ) {
    return this.createListResource.execute(
      `${Constants.organisationsPath}/${organisationId}/indexes/${organisationIndexId}/category`,
      organisationIndexes
    );
  }
}
